import NotesModal from './NotesModal';

export default NotesModal;
